module.exports = __webpack_public_path__ + "img/envelope-5.d773c6f1.svg";